/**
 * AP · Slot tracking (Phase 8) — đo performance từng vị trí upsell.
 *
 * 1. Add-to-cart theo slot: bắn cùng lúc
 *    - Shopify.analytics.publish('afropenda:slot_add_to_cart', {...}) — để ngỏ
 *      cho Customer Events / Meta CAPI subscribe sau này.
 *    - GA4 add_to_cart với item_list_name = slot (chỉ khi gtag có mặt).
 *    Điểm bắn: capture-phase submit trên form /cart/add — cùng điểm với
 *    ap-slot-cart.js nên slot input đã được gắn trước đó.
 * 2. Impression: IntersectionObserver trên [data-slot] — view_item_list
 *    1 lần/slot/pageview (đo được CTR slot, không chỉ volume add).
 *
 * Consent: store bán US là chính — gtag bắn thẳng, KHÔNG qua lớp consent
 * Shopify Customer Privacy. Nếu cần EU compliance: bọc fire() bằng
 * window.Shopify.customerPrivacy.userCanBeTracked() (TODO — chờ user quyết).
 */
(function () {
  'use strict';

  // 2026-08-17 (QA): app Google & YouTube đã bắn add_to_cart/view_item_list chuẩn qua Web Pixel →
  // KHÔNG bắn trùng tên. Chỉ bắn event riêng slot_* và CHỈ khi theme có GA4 direct (ap_ga4_id → data-ga4).
  var GA4_ON = !!(document.currentScript && document.currentScript.dataset.ga4);
  function ga(eventName, params) {
    if (GA4_ON && typeof window.gtag === 'function') window.gtag('event', eventName, params);
  }
  function shopifyPublish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* analytics không được chặn flow mua hàng */ }
  }

  // ---- 1. add-to-cart theo slot ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var slotInput = form.querySelector('input[name="properties[_slot]"]');
    var slot = slotInput ? slotInput.value : 'unattributed';
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var variantId = idInput ? idInput.value : null;

    var payload = { slot: slot, variant_id: variantId, url: location.pathname };
    shopifyPublish('afropenda:slot_add_to_cart', payload);
    ga('slot_add_to_cart', {
      item_list_name: slot,
      items: [{ item_id: variantId ? String(variantId) : undefined, item_list_name: slot, quantity: 1 }],
    });
  }, true);

  // ---- 2. impression per slot ----
  var seen = {};
  function observeSlots() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var slot = entry.target.getAttribute('data-slot');
        if (!slot || seen[slot]) return;
        seen[slot] = true;
        io.unobserve(entry.target);
        shopifyPublish('afropenda:slot_view', { slot: slot, url: location.pathname });
        ga('slot_view', { item_list_name: slot });
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('[data-slot]').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeSlots);
  else observeSlots();
  document.addEventListener('shopify:section:load', observeSlots);
})();
